import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import { getEntities, getGTMData } from '@swf/core/analytics/utils';
import type { TrackingContextValue } from '@swf/core/providers/TrackingContext';

/**
 * Firest when a widget is presented to the user
 */
export interface WidgetView {}

export const widgetView = (data: WidgetView, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'widget_view', ...data, ...getGTMData(context) });
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/widget_view/jsonschema/1-0-0', data },
    context: getEntities(context)
  });
};
